export enum DeliveryMode {
  Standard = 0,
  Rush = 1,
  SpecificDate = 2,
}
